import { apiRequest } from 'utils/request'

export const fetchVehicleSnapshots = ({ serialNumber }) =>
  apiRequest({ uri: `/vehicles/${serialNumber}/snapshots` })

export const createVehicleSnapshot = ({ serialNumber }) =>
  apiRequest({
    uri: `/vehicles/${serialNumber}/snapshots`,
    method: 'POST',
    body: {},
  })

export const deleteVehicleSnapshot = ({ serialNumber, snapshotId }) =>
  apiRequest({
    uri: `/vehicles/${serialNumber}/snapshots/${snapshotId}`,
    method: 'DELETE',
  })

export const fetchVehicleAsBuilt = ({ serialNumber }) =>
  apiRequest({ uri: `/vehicles/${serialNumber}/as-built` })
